import React from 'react';

export const FullScreenLoader: React.FC = () => {
  const containerStyle: React.CSSProperties = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: '#1a1a1a', // Matches your dashboard background
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999, // Above everything
  };

  const spinnerStyle: React.CSSProperties = {
    width: '60px',
    height: '60px',
    border: '5px solid #333',
    borderTop: '5px solid #daff00', // Dash/Out lime green
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  };

  return (
    <div style={containerStyle}>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
      <div style={spinnerStyle} />
      <h2
        style={{
          color: '#fff',
          marginTop: '20px',
          letterSpacing: '2px',
          fontWeight: 300,
        }}>
        Loading ...
      </h2>
    </div>
  );
};
